export const accordionContainerClassName = `
    max-w-[384px]
    border
    border-primary
    p-4
`
